import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, from } from "rxjs";
import { lastValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "../auth/auth.service";
import { fromPromise } from "rxjs-compat/observable/fromPromise";
import { StoreService } from "src/app/services-store/store.service";

@Injectable({
  providedIn: "root",
})
export class IapHttpInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthService, private store: StoreService) {}

  private async handleAccess(
    request: HttpRequest<any>,
    next: HttpHandler,
    agentId: string,
    appId: string
  ): Promise<HttpEvent<any>> {
    const headerSettings: { [name: string]: string | string[] } = {};

    // Try to acquire token
    let token: string | null;
    try {
      token = await this.authService.getCacheAccessToken();
    } catch (error) {
      console.error("Failed to acquire token:", error);
      throw error;
    }

    // Assign token if present
    if (token) {
      headerSettings["Authorization"] = `Bearer ${token}`;
    }

    // Add optional headers for subscription key, appId, and agentId
    if (environment.apiSubscriptionEnabled && environment.apiSubscriptionKey) {
      headerSettings["Ocp-Apim-Subscription-Key"] =
        environment.apiSubscriptionKey;
    }
    if (appId && appId !== "00000000000") {
      headerSettings["appId"] = appId;
    }
    if (agentId) {
      headerSettings["agentId"] = agentId;
    }

    // Return the cloned request with headers
    return lastValueFrom(
      next.handle(request.clone({ setHeaders: headerSettings }))
    );
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return fromPromise(
      this.handleAccess(
        req,
        next,
        this.store.authStore.user.agentId,
        this.store?.applicantInfoStore?.applicantInfo?.appId
      )
    );
  }
}
